import booksIcon from '../images/books.svg';
import bodyIcon from '../images/body.svg';
// import mortarIcon from '../images/mortar.svg';
// import plantIcon from '../images/plant.svg';
// import recipeIcon from '../images/recipe.svg';
// import pillIcon from '../images/pill.svg';

const routes = [
  // {
  //   id: 1,
  //   image: mortarIcon,
  //   title: 'Remedies',
  //   to: '/browse',
  // },
  {
    id: 1,
    image: booksIcon,
    title: 'Services',
    to: '/services',
  },
  {
    id: 2,
    image: bodyIcon,
    title: 'Discover Your Dosha',
    to: '/dosha-quiz',
  },
  {
    id: 3,
    image: bodyIcon,
    title: 'About Us',
    to: '/about',
  },
];

export default routes;
